import {
    addEmailDTO,
    authDTO,
    authNoTokenDTO,
    changePassDTO,
    forgotPassDTO,
    loginDTO,
    signInPasswordlessDTO,
    signInPasswordlessEndDTO,
    signUpDTO,
    signUpPasswordless,
    tokenValidate,
} from '.';
import {
    AUTHENTICATION,
    IAddEmail,
    IAddEmailClear,
    IAddEmailEnd,
    IAddEmailEndFailure,
    IAddEmailEndSuccess,
    IAddEmailFailure,
    IAddEmailSuccess,
    IAddPhone,
    IAddPhoneClear,
    IAddPhoneEnd,
    IAddPhoneEndFailure,
    IAddPhoneEndSuccess,
    IAddPhoneFailure,
    IAddPhoneSuccess,
    IBaseURLRetrieved,
    IChangePassword,
    IChangePasswordClear,
    IChangePasswordFailure,
    IChangePasswordSuccess,
    IChangeRegisterLanguage,
    IEditUsername,
    IEditUsernameClean,
    IEditUsernameEnd,
    IEditUsernameEndFailure,
    IEditUsernameEndSuccess,
    IEditUsernameFailure,
    IEditUsernameSuccess,
    IForgotPassword,
    IForgotPasswordFailure,
    IForgotPasswordFinish,
    IForgotPasswordFinishFailure,
    IForgotPasswordFinishSuccess,
    IForgotPasswordSuccess,
    IGetAuthData,
    IGetAuthDataFailure,
    IGetAuthDataSuccess,
    IGetForgotPasswordEmail,
    IGetForgotPasswordEmailFailure,
    IGetForgotPasswordEmailSuccess,
    ILogoutNew,
    ILogoutNewFailure,
    ILogoutNewSuccess,
    IRotateToken,
    IRotateTokenFailure,
    IRotateTokenSuccess,
    ISetIsAuthenticated,
    ISetIsError,
    ISignInCheck,
    ISignInCheckClear,
    ISignInCheckResult,
    ISignInSwitchToEmail,
    ISignInSwitchToPhone,
    ISignUpNew,
    ISignUpNewFailure,
    ISignUpNewPasswordless,
    ISignUpNewPasswordlessFailure,
    ISignUpNewPasswordlessSuccess,
    ISignUpNewSuccess,
    ISingIn,
    ISingInFailure,
    ISingInPasswordless,
    ISingInPasswordlessFailure,
    ISingInPasswordlessFinish,
    ISingInPasswordlessFinishFailure,
    ISingInPasswordlessFinishSuccess,
    ISingInPasswordlessSuccess,
    ISingInSuccess,
    IValidateToken,
    IValidateTokenFailure,
    IValidateTokenSuccess,
} from './types';

export function setIsAuthenticated(value: boolean): ISetIsAuthenticated {
    console.log('setIsAuthenticated', value);
    return {
        type: AUTHENTICATION.SET_IS_AUTHENTICATED,
        payload: value,
    };
}
export function setIsBaseURLRetrieved(value: boolean): IBaseURLRetrieved {
    return {
        type: AUTHENTICATION.SET_IS_BASE_URL_RETRIEVED,
        payload: value,
    };
}
export function setIsError(value: string): ISetIsError {
    return {
        type: AUTHENTICATION.SET_IS_ERROR,
        payload: value,
    };
}
/// new auth
export function getAuthData(): IGetAuthData {
    return { type: AUTHENTICATION.GET_AUTH_DATA };
}
export function getAuthDataSuccess(value: authNoTokenDTO): IGetAuthDataSuccess {
    return { type: AUTHENTICATION.GET_AUTH_DATA_SUCCESS, payload: value };
}
export function getAuthDataFailure(value: any): IGetAuthDataFailure {
    return { type: AUTHENTICATION.GET_AUTH_DATA_FAILURE, payload: value };
}

export function rotateToken(): IRotateToken {
    return { type: AUTHENTICATION.ROTATE_TOKEN };
}
export function rotateSuccess(value: authDTO): IRotateTokenSuccess {
    return { type: AUTHENTICATION.ROTATE_TOKEN_SUCCESS, payload: value };
}
export function rotateFailure(value: any): IRotateTokenFailure {
    return { type: AUTHENTICATION.ROTATE_TOKEN_FAILURE, payload: value };
}

export function signIn(value: loginDTO): ISingIn {
    return { type: AUTHENTICATION.SIGN_IN, payload: value };
}
export function signInSuccess(value: authDTO): ISingInSuccess {
    return { type: AUTHENTICATION.SIGN_IN_SUCCESS, payload: value };
}
export function signInFailure(value: string): ISingInFailure {
    return { type: AUTHENTICATION.SIGN_IN_FAILURE, payload: value };
}

export function forgotPassword(email: string): IForgotPassword {
    return { type: AUTHENTICATION.FORGOT_PASSWORD, payload: email };
}

export function forgotPasswordSuccess(value: any): IForgotPasswordSuccess {
    return { type: AUTHENTICATION.FORGOT_PASSWORD_SUCCESS, payload: value };
}

export function forgotPasswordFailure(value: any): IForgotPasswordFailure {
    return { type: AUTHENTICATION.FORGOT_PASSWORD_FAILURE, payload: value };
}

export function forgotPasswordFinish(dto: forgotPassDTO): IForgotPasswordFinish {
    return { type: AUTHENTICATION.FORGOT_PASSWORD_END, payload: dto };
}

export function forgotPasswordFinishSuccess(value: any): IForgotPasswordFinishSuccess {
    return { type: AUTHENTICATION.FORGOT_PASSWORD_END_SUCCESS, payload: value };
}

export function forgotPasswordFinishFailure(value: any): IForgotPasswordFinishFailure {
    return { type: AUTHENTICATION.FORGOT_PASSWORD_END_FAILURE, payload: value };
}

export function getForgotPasswordEmail(token: string): IGetForgotPasswordEmail {
    return { type: AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL, payload: token };
}

export function getForgotPasswordEmailSuccess(value: string): IGetForgotPasswordEmailSuccess {
    return { type: AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL_SUCCESS, payload: value };
}

export function getForgotPasswordEmailFailure(value: any): IGetForgotPasswordEmailFailure {
    return { type: AUTHENTICATION.GET_FORGOT_PASSWORD_EMAIL_FAILURE, payload: value };
}

export function changePasswordNew(value: changePassDTO): IChangePassword {
    return { type: AUTHENTICATION.CHANGE_PASSWORD, payload: value };
}
export function changePasswordSuccess(value: any): IChangePasswordSuccess {
    return { type: AUTHENTICATION.CHANGE_PASSWORD_SUCCESS, payload: value };
}
export function changePasswordFailure(value: number): IChangePasswordFailure {
    return { type: AUTHENTICATION.CHANGE_PASSWORD_FAILURE, payload: value };
}
export function changePasswordClear(): IChangePasswordClear {
    return { type: AUTHENTICATION.CHANGE_PASSWORD_CLEAR };
}
export function logoutNew(redirectTo = '', silently = false): ILogoutNew {
    return {
        type: AUTHENTICATION.LOGOUT_NEW_REQUEST,
        payload: { redirectTo, silently },
    };
}

export function logoutNewSuccess(redirectTo = ''): ILogoutNewSuccess {
    return {
        type: AUTHENTICATION.LOGOUT_NEW_SUCCESS,
        payload: redirectTo,
    };
}

export function logoutNewFailure(): ILogoutNewFailure {
    return {
        type: AUTHENTICATION.LOGOUT_NEW_FAILURE,
    };
}

export function validateToken(value: string): IValidateToken {
    return { type: AUTHENTICATION.TOKEN_VALIDATE, payload: value };
}

export function validateTokenSuccess(value: tokenValidate): IValidateTokenSuccess {
    return { type: AUTHENTICATION.TOKEN_VALIDATE_SUCCESS, payload: value };
}

export function validateTokenFailure(value: any): IValidateTokenFailure {
    return { type: AUTHENTICATION.TOKEN_VALIDATE_FAILURE, payload: value };
}

export function signUpNew(value: signUpDTO): ISignUpNew {
    return { type: AUTHENTICATION.SIGN_UP_NEW, payload: value };
}
export function signUpNewSuccess(value: authDTO): ISignUpNewSuccess {
    return { type: AUTHENTICATION.SIGN_UP_NEW_SUCCESS, payload: value };
}
export function signUpNewFailure(value: any): ISignUpNewFailure {
    return { type: AUTHENTICATION.SIGN_UP_NEW_FAILURE, payload: value };
}
export function changeLanguageRegisterNew(value: string): IChangeRegisterLanguage {
    return { type: AUTHENTICATION.CHANGE_LANGUAGE, payload: value };
}
export function signInCheck(value: string): ISignInCheck {
    return { type: AUTHENTICATION.SIGN_IN_CHECK, payload: value };
}
export function signInCheckResult(result: boolean, isEmail: boolean, reason: string): ISignInCheckResult {
    return { type: AUTHENTICATION.SIGN_IN_CHECK_RESULT, payload: { result, isEmail, reason } };
}

export function signInCheckClear(): ISignInCheckClear {
    return { type: AUTHENTICATION.SIGN_IN_CHECK_CLEAR };
}

export function signInPasswordless(value: signInPasswordlessDTO): ISingInPasswordless {
    return { type: AUTHENTICATION.SIGN_IN_PASSWORLESS, payload: value };
}
export function signInPasswordlessSuccess(value: signInPasswordlessDTO): ISingInPasswordlessSuccess {
    return { type: AUTHENTICATION.SIGN_IN_PASSWORLESS_SUCCESS, payload: value };
}
export function signInPasswordlessFailure(value: any): ISingInPasswordlessFailure {
    return { type: AUTHENTICATION.SIGN_IN_PASSWORLESS_FAILURE, payload: value };
}

export function signInPasswordlessFinish(value: signInPasswordlessEndDTO): ISingInPasswordlessFinish {
    return { type: AUTHENTICATION.SIGN_IN_PASSWORLESS_END, payload: value };
}
export function signInPasswordlessFinishSuccess(
    value: authDTO & signInPasswordlessEndDTO,
): ISingInPasswordlessFinishSuccess {
    return { type: AUTHENTICATION.SIGN_IN_PASSWORLESS_END_SUCCESS, payload: value };
}
export function signInPasswordlessFinishFailure(value: any): ISingInPasswordlessFinishFailure {
    return { type: AUTHENTICATION.SIGN_IN_PASSWORLESS_END_FAILURE, payload: value };
}
export function signUpNewPasswordless(value: signUpPasswordless): ISignUpNewPasswordless {
    return { type: AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS, payload: value };
}
export function signUpNewPasswordlessSuccess(value: any): ISignUpNewPasswordlessSuccess {
    return { type: AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS_SUCCESS, payload: value };
}
export function signUpNewPasswordlessFailure(value: any): ISignUpNewPasswordlessFailure {
    return { type: AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS_FAILURE, payload: value };
}

export function addPhone(value: string): IAddPhone {
    return { type: AUTHENTICATION.ADD_PHONE, payload: value };
}
export function addPhoneSuccess(value: any): IAddPhoneSuccess {
    return { type: AUTHENTICATION.ADD_PHONE_SUCCESS, payload: value };
}
export function addPhoneFailure(value: any): IAddPhoneFailure {
    return { type: AUTHENTICATION.ADD_PHONE_FAILURE, payload: value };
}

export function addPhoneEnd(code: string, phone: string): IAddPhoneEnd {
    return { type: AUTHENTICATION.ADD_PHONE_END, payload: { code, phone } };
}
export function addPhoneEndSuccess(code: string, phone: string): IAddPhoneEndSuccess {
    return { type: AUTHENTICATION.ADD_PHONE_END_SUCCESS, payload: { code, phone } };
}
export function addPhoneEndFailure(value: any): IAddPhoneEndFailure {
    return { type: AUTHENTICATION.ADD_PHONE_END_FAILURE, payload: value };
}
export function addPhoneClear(): IAddPhoneClear {
    return { type: AUTHENTICATION.ADD_PHONE_CLEAR };
}
export function addEmail(value: string): IAddEmail {
    return { type: AUTHENTICATION.ADD_EMAIL, payload: value };
}
export function addEmailSuccess(value: any): IAddEmailSuccess {
    return { type: AUTHENTICATION.ADD_EMAIL_SUCCESS, payload: value };
}
export function addEmailFailure(value: any): IAddEmailFailure {
    return { type: AUTHENTICATION.ADD_EMAIL_FAILURE, payload: value };
}

export function addEmailEnd(value: addEmailDTO): IAddEmailEnd {
    return { type: AUTHENTICATION.ADD_EMAIL_END, payload: value };
}
export function addEmailEndSuccess(value: any): IAddEmailEndSuccess {
    return { type: AUTHENTICATION.ADD_EMAIL_END_SUCCESS, payload: value };
}
export function addEmailEndFailure(value: any): IAddEmailEndFailure {
    return { type: AUTHENTICATION.ADD_EMAIL_END_FAILURE, payload: value };
}
export function addEmailClear(): IAddEmailClear {
    return { type: AUTHENTICATION.ADD_EMAIL_CLEAR };
}

export function editUsername(username: string, type: 'auth0' | 'sms'): IEditUsername {
    return { type: AUTHENTICATION.EDIT_USERNAME, payload: { username, type } };
}
export function editUsernameSuccess(username: string, type: 'auth0' | 'sms'): IEditUsernameSuccess {
    return { type: AUTHENTICATION.EDIT_USERNAME_SUCCESS, payload: { username, type } };
}
export function editUsernameFailure(code: any, type: 'auth0' | 'sms'): IEditUsernameFailure {
    return { type: AUTHENTICATION.EDIT_USERNAME_FAILURE, payload: { code, type } };
}

export function editUsernameEnd(
    username: string,
    type: 'auth0' | 'sms',
    verificationCode: string,
    password: string,
): IEditUsernameEnd {
    return { type: AUTHENTICATION.EDIT_USERNAME_END, payload: { username, type, password, verificationCode } };
}
export function editUsernameEndSuccess(
    username: string,
    type: 'auth0' | 'sms',
    verificationCode: string,
    password: string,
): IEditUsernameEndSuccess {
    return { type: AUTHENTICATION.EDIT_USERNAME_END_SUCCESS, payload: { username, type, password, verificationCode } };
}
export function editUsernameEndFailure(code: any, type: 'auth0' | 'sms'): IEditUsernameEndFailure {
    return { type: AUTHENTICATION.EDIT_USERNAME_END_FAILURE, payload: { code, type } };
}
export function editUsernameClear(value: 'sms' | 'auth0'): IEditUsernameClean {
    return { type: AUTHENTICATION.EDIT_USERNAME_CLEAR, payload: value };
}

export function switchToEmail(): ISignInSwitchToEmail {
    return { type: AUTHENTICATION.SIGN_IN_SWITCH_TO_EMAIL };
}
export function switchToPhone(): ISignInSwitchToPhone {
    return { type: AUTHENTICATION.SIGN_IN_SWITCH_TO_PHONE };
}
